module.exports = __webpack_public_path__ + "media/images/top-header-07149928e0f3806a245d1001f1ba9f03.jpeg";